module.exports = __webpack_public_path__ + "media/images/logo_p1-ba55fb94e9ade5490ba3c99148685418.svg";